(function () {
    const config = window.uptalentRegister || {};
    const messages = config.messages || {};

    const form = document.getElementById("uptalent-register-form") || document.querySelector(".register__form");
    const submitBtn = document.getElementById("register-submit");
    const fullNameInput = document.getElementById("reg_full_name");
    const emailInput = document.getElementById("reg_email");
    const emailClearBtn = document.getElementById("reg-email-clear");
    const emailError = document.getElementById("reg-email-error");
    const usernameInput = document.getElementById("reg_username");
    const usernameError = document.getElementById("reg-username-error");
    const passwordInput = document.getElementById("reg_password");
    const gdprInput = document.getElementById("reg_gdpr_consent");

    if (!form || !submitBtn || !fullNameInput || !emailInput || !usernameInput || !passwordInput || !gdprInput) {
        return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const usernameCharsPattern = /^[a-zA-Z0-9.-]*$/;
    const usernamePattern = /^[a-zA-Z0-9.-]{3,40}$/;
    const usernameInvalidCharsMessage =
        config.usernameInvalidChars ||
        messages.usernameInvalidChars ||
        "Te znaki nie są dozwolone. Login może zawierać tylko litery, cyfry, kropki lub myślniki.";
    const usernameLengthMessage =
        config.usernameLengthError ||
        messages.usernameLength ||
        "Login musi mieć od 3 do 40 znaków.";

    function setSubmitDisabled(isDisabled) {
        submitBtn.disabled = isDisabled;
        submitBtn.classList.toggle("register__submit--disabled", isDisabled);
    }

    function clearEmailError() {
        emailInput.classList.remove("register__input--error");
        emailInput.closest(".register__field--email")?.classList.remove("register__field--error");
        emailInput.removeAttribute("aria-invalid");

        if (emailError) {
            emailError.hidden = true;
        }

        if (emailClearBtn) {
            emailClearBtn.hidden = true;
        }
    }

    function showEmailError() {
        emailInput.classList.add("register__input--error");
        emailInput.closest(".register__field--email")?.classList.add("register__field--error");
        emailInput.setAttribute("aria-invalid", "true");

        if (emailError) {
            emailError.textContent = config.emailError || "Nieprawidłowy adres e-mail.";
            emailError.hidden = false;
        }

        if (emailClearBtn) {
            emailClearBtn.hidden = false;
        }

        setSubmitDisabled(true);
    }

    function validateEmail() {
        const value = emailInput.value.trim();

        if (!value) {
            clearEmailError();
            return false;
        }

        if (!emailPattern.test(value)) {
            showEmailError();
            return false;
        }

        clearEmailError();
        return true;
    }

    function getUsernameField() {
        return usernameInput.closest(".register__field--username") || usernameInput.closest(".register__field");
    }

    function clearUsernameError() {
        usernameInput.classList.remove("register__input--error");
        getUsernameField()?.classList.remove("register__field--error");
        usernameInput.removeAttribute("aria-invalid");

        if (usernameError) {
            usernameError.hidden = true;
        }
    }

    function showUsernameError(message) {
        usernameInput.classList.add("register__input--error");
        getUsernameField()?.classList.add("register__field--error");
        usernameInput.setAttribute("aria-invalid", "true");

        if (usernameError) {
            usernameError.textContent = message;
            usernameError.hidden = false;
        }

        setSubmitDisabled(true);
    }

    function getUsernameErrorMessage(value, checkLength) {
        if (!value) {
            return "";
        }

        if (!usernameCharsPattern.test(value)) {
            return usernameInvalidCharsMessage;
        }

        if (checkLength && (value.length < 3 || value.length > 40)) {
            return usernameLengthMessage;
        }

        return "";
    }

    function validateUsername(options) {
        const checkLength = !options || options.checkLength !== false;
        const value = usernameInput.value.trim();

        if (!value) {
            clearUsernameError();
            return false;
        }

        const errorMessage = getUsernameErrorMessage(value, checkLength);

        if (errorMessage) {
            showUsernameError(errorMessage);
            return false;
        }

        clearUsernameError();
        return usernamePattern.test(value);
    }

    function isFormValid() {
        const fullName = fullNameInput.value.trim();
        const email = emailInput.value.trim();
        const username = usernameInput.value.trim();
        const password = passwordInput.value;

        if (fullName.length < 2 || fullName.length > 80) {
            return false;
        }

        if (!email || !emailPattern.test(email)) {
            return false;
        }

        if (!usernamePattern.test(username)) {
            return false;
        }

        if (password.length < 8) {
            return false;
        }

        if (!gdprInput.checked) {
            return false;
        }

        return true;
    }

    function updateSubmitState() {
        if (
            emailInput.classList.contains("register__input--error") ||
            usernameInput.classList.contains("register__input--error")
        ) {
            setSubmitDisabled(true);
            return;
        }

        setSubmitDisabled(!isFormValid());
    }

    emailInput.addEventListener("input", function () {
        if (emailInput.classList.contains("register__input--error")) {
            validateEmail();
        }

        updateSubmitState();
    });

    emailInput.addEventListener("blur", function () {
        if (emailInput.value.trim()) {
            validateEmail();
        }

        updateSubmitState();
    });

    if (emailClearBtn) {
        emailClearBtn.addEventListener("click", function () {
            emailInput.value = "";
            emailInput.focus();
            clearEmailError();
            updateSubmitState();
        });
    }

    usernameInput.addEventListener("input", function () {
        const value = usernameInput.value.trim();
        const hasInvalidChars = Boolean(value) && !usernameCharsPattern.test(value);
        const isTooLong = value.length > 40;
        const alreadyShowingError = usernameInput.classList.contains("register__input--error");

        if (hasInvalidChars || isTooLong || alreadyShowingError) {
            validateUsername({ checkLength: alreadyShowingError || isTooLong });
        } else {
            clearUsernameError();
        }

        updateSubmitState();
    });

    usernameInput.addEventListener("blur", function () {
        if (usernameInput.value.trim()) {
            validateUsername({ checkLength: true });
        }

        updateSubmitState();
    });

    [fullNameInput, passwordInput, gdprInput].forEach(function (input) {
        input.addEventListener("input", updateSubmitState);
        input.addEventListener("change", updateSubmitState);
    });

    form.addEventListener("submit", function (event) {
        const emailValid = validateEmail();
        const usernameValid = validateUsername({ checkLength: true });

        if (!emailValid || !usernameValid || !isFormValid()) {
            event.preventDefault();
            updateSubmitState();
        }
    });

    updateSubmitState();
})();
